import script from "./SummaryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryPage.vue?vue&type=script&setup=true&lang=js"

import "./SummaryPage.vue?vue&type=style&index=0&id=593f10c8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593f10c8"]])

export default __exports__